// <svg width="50" height="50" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M2 6H30M2.00781 15.5H30.0078M2.01562 25H30.0156" stroke="white" strokeWidth="3" />
// </svg>

import { useScreenSize } from '../../hooks/useScreenSize'

const BurgerIcon: React.FC = () => {
    const { isMobile } = useScreenSize()
    return (
        <svg
            width={isMobile ? '36' : '48'}
            height={isMobile ? '36' : '48'}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="2" y="7" width="44" height="6" rx="3" fill="#FFFFFF" />
            <rect x="2" y="21" width="44" height="6" rx="3" fill="#FFFFFF" />
            <rect x="2" y="35" width="44" height="6" rx="3" fill="#FFFFFF" />
        </svg>
    )
}

BurgerIcon.displayName = 'BurgerIcon'

export default BurgerIcon
